export default __webpack_public_path__ + "static/look-1-alt-mobile-4f4eb31b524f4299c97927cd55963ebf.png";